import React from "react";
import { Checkbox, Form, FormItem, Input } from "formik-antd";
import { Button, Form as AntForm, Spin } from "antd";
import { formItemLayout, tailFormItemLayout } from "../../../utils";
import { Formik } from "formik";
import * as Yup from "yup";
import { useTranslate } from "../../../hooks";
import DraftField from "../../../components/DraftCke";

const FormReceipt = ({ data, onSubmit, onCancel }) => {
  const { translate } = useTranslate();

  const [initialData] = React.useState({
    paymentName: data?.tenant?.paymentName || "",
  });

  const FormSchema = () =>
    Yup.object({
      paymentName: Yup.string().required(
        translate(
          "order.receipt.paymentname.field.required.type",
          "領収書氏名を入力してください！",
        ),
      ),
    });

  return (
    <Formik
      enableReinitialize
      initialValues={initialData}
      validationSchema={FormSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => {
        return (
          <Form {...formItemLayout}>
            <FormItem
              name="paymentName"
              label={translate("order.receipt.paymentname.field", "領収書氏名")}
              required
            >
              <Input
                name="paymentName"
                placeholder={translate(
                  "order.receipt.paymentname.field",
                  "領収書氏名",
                )}
              />
            </FormItem>
            <AntForm.Item {...tailFormItemLayout}>
              <Button
                className="button"
                style={{ marginRight: 10 }}
                htmlType="submit"
                type="primary"
                loading={isSubmitting}
              >
                {translate("system.btn.save", "Save")}
              </Button>
            </AntForm.Item>
          </Form>
        );
      }}
    </Formik>
  );
};

export default FormReceipt;
